import React from 'react';
import { BaasicInput, BaasicSelect, BaasicErrorModal, BaasicConfirmModal } from 'core/components';
import _ from 'lodash';
import { renderIf } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

function DivTableRow({ data }) {
	let rowId = 'table__settings__item' + data.key;
	return (
		<div id={rowId} className="table__settings__item" onClick={() => data.viewStore.onColumnSelect(data.key)}>
			{data.label}
		</div>
	);
}

const BaasicTableSettingsTemplate = ({ viewStore, t }) => {
	return (
		<React.Fragment>
			<div className="ReactModal__header">
				<div className="flex--secondary">
					<h3 className="spc--bottom--sml">{t('BAASICTABLESETTINGS.TABLESETTINGS')}</h3>
					{viewStore.templates && viewStore.templates.length > 0 && (
						<BaasicSelect
							placeholder={t('BAASICTABLESETTINGS.SELECT')}
							options={viewStore.options.slice()}
							onChange={viewStore.onTemplateSelect}
							value={viewStore.selectedTemplate}
							className="w--200--px spc--bottom--sml"
						/>
					)}
				</div>
			</div>

			<div className="ReactModal__body">
				<div className="table__settings spc--bottom--sml" id="tableSettings">
					<div className="table__settings__box">
						<div className="table__settings__scroll">
							<div className="table__settings__item first">{t('BAASICTABLESETTINGS.AVAILABLECOLUMNS')}</div>
							<div>
								{viewStore.availableColumns.map(column => {
									let data = {
										key: column.key,
										label: t(column.title),
										viewStore: viewStore,
									};
									return <DivTableRow key={column.key} data={data} />;
								})}
							</div>
						</div>
					</div>
					<div className="table__settings__box narrow">
						<button
							className="btn btn--icon btn--primary spc--bottom--sml"
							type="button"
							onClick={() => viewStore.onTransferColumn('add')}
							disabled={viewStore.addButton}
						>
							<i className="fa fa-arrow-right"></i>
						</button>
						<button
							className="btn btn--icon btn--primary"
							type="button"
							onClick={() => viewStore.onTransferColumn('remove')}
							disabled={viewStore.removeButton}
						>
							<i className="fa fa-arrow-left"></i>
						</button>
					</div>
					<div className="table__settings__box">
						<div className="table__settings__scroll">
							<div className="table__settings__item first">{t('BAASICTABLESETTINGS.SELECTEDCOLUMNS')}</div>
							<div>
								{viewStore.selectedColumns
									.filter(column => {
										if (column.locked) {
											return false;
										} else {
											return true;
										}
									})
									.map(column => {
										let data = {
											key: column.key,
											label: t(column.title),
											viewStore: viewStore,
										};
										return <DivTableRow key={column.key} data={data} />;
									})}
							</div>
						</div>
					</div>
					<div className="table__settings__box narrow last">
						<button
							className="btn btn--icon btn--primary spc--bottom--sml upbtn"
							type="button"
							onClick={() => viewStore.moveColumn('up')}
							disabled={viewStore.moveUpButton}
						>
							<i className="fa fa-angle-up"></i>
						</button>
						<button
							className="btn btn--icon btn--primary downbtn"
							type="button"
							onClick={() => viewStore.moveColumn('down')}
							disabled={viewStore.moveDownButton}
						>
							<i className="fa fa-angle-down"></i>
						</button>
					</div>
				</div>
			</div>

			<form className="ReactModal__footer" onSubmit={viewStore.form.onSubmit}>
				{((viewStore.templateAlreadyExists && !viewStore.newTemplate && !viewStore.templateAlreadyExistsColumns) ||
					(viewStore.newTemplateConfirmed &&
						!viewStore.isInput &&
						!viewStore.templateAlreadyExistsColumns &&
						!viewStore.saveButton &&
						!viewStore.templateAlreadyExists) ||
					(viewStore.newTemplateConfirmed && viewStore.templateAlreadyExistsColumns && !viewStore.newTemplate) ||
					viewStore.newTemplateConfirmed) && (
					<div className="ReactModal__footer--template">
						{viewStore.newTemplateConfirmed && (
							<div className="inputgroup w--400--px">
								<div className="inputgroup--main">
									<BaasicInput
										onKeyUp={viewStore.validateTemplateName}
										field={viewStore.form.$('templateName')}
										showCheckmark={false}
										autoFocus={viewStore.isInput}
										onBlur={viewStore.onBlur}
										validation={false}
										className="spc--right--sml"
									/>
								</div>
								<div className="inputgroup--aside">
									<div className="inputgroup">
										<label className="form__label">&nbsp;</label>
										<button type="button" className="btn btn--med btn--outline" onClick={viewStore.cancelNewTemplate}>
											{t('CANCEL')}
										</button>
									</div>
								</div>
							</div>
						)}
						{((viewStore.templateAlreadyExists && !viewStore.newTemplate && !viewStore.templateAlreadyExistsColumns) ||
							(viewStore.newTemplateConfirmed &&
								viewStore.isTemplateNameEmpty &&
								!viewStore.isInput &&
								!viewStore.templateAlreadyExistsColumns &&
								!viewStore.templateAlreadyExists) ||
							(viewStore.newTemplateConfirmed && viewStore.templateAlreadyExistsColumns && !viewStore.newTemplate)) && (
							<ul className="message message--error spc--bottom--sml">
								{viewStore.templateAlreadyExists && !viewStore.newTemplate && !viewStore.templateAlreadyExistsColumns && (
									<li>
										<p className="type--tny type--color--error">{t('EXISTINGTEMPLATENAME')}</p>
									</li>
								)}
								{viewStore.newTemplateConfirmed &&
									viewStore.isTemplateNameEmpty &&
									!viewStore.isInput &&
									!viewStore.templateAlreadyExistsColumns &&
									!viewStore.templateAlreadyExists && (
										<li>
											<p className="type--tny type--color--error">{t('MESSAGES.REQUIRED.TEMPLATE.NAME')}</p>
										</li>
									)}
								{viewStore.newTemplateConfirmed && viewStore.templateAlreadyExistsColumns && !viewStore.newTemplate && (
									<li>
										<p className="type--tny type--color--error">
											{t('BAASICTABLESETTINGS.EXISTINGTEMPLATECOLUMNLAYOUT', {
												name: viewStore.templateAlreadyExistsColumns,
											})}
										</p>
									</li>
								)}
							</ul>
						)}
					</div>
				)}

				<div className="flex--secondary">
					<div>
						<button
							className="btn btn--med btn--secondary spc--right--sml spc--bottom--sml"
							onClick={viewStore.tableSettingsModal.close}
						>
							{t('CLOSE')}
						</button>
						{renderIf(viewStore.templates && viewStore.templates.length > 0 && viewStore.selectedTemplate)(
							<button
								type="button"
								className="btn btn--med spc--right--sml spc--bottom--sml"
								onClick={viewStore.openConfirmModal}
								disabled={
									viewStore.baasicTableSettingsKey === 'FulfillmentOrdersTableSettings' &&
									viewStore.selectedTemplate.label === 'default template'
								}
							>
								{t('BAASICTABLESETTINGS.DELETE')}
							</button>
						)}
					</div>

					<div>
						{renderIf(viewStore.newTemplate)(
							<button
								type="button"
								className="btn btn--med btn--primary spc--right--tny spc--right--sml spc--bottom--sml"
								onClick={viewStore.onNewTemplate}
							>
								{t('BAASICTABLESETTINGS.SAVEASNEWTEMPLATE')}
							</button>
						)}
						<button
							type="submit"
							className="btn btn--med btn--primary spc--bottom--sml"
							onClick={viewStore.onSaveAndApply}
							disabled={!viewStore.saveButton}
						>
							{t('BAASICTABLESETTINGS.SAVEANDAPPLY')}
						</button>
					</div>
				</div>
			</form>
			<BaasicErrorModal modalParams={viewStore.errorModal} />
			<BaasicConfirmModal modalParams={viewStore.confirmModal} />
		</React.Fragment>
	);
};

export default defaultTemplate(BaasicTableSettingsTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/table/BaasicTableSettingsTemplate.jsx